var NavTemplate = require('./nav-template');
var NavDrawerTemplate = require('./drawer/template');
var NavDomElement = require('./nav-dom-elements');
var NavDrawerDomElement = require('./drawer/dom-elements');
var NavDataAccess = require('./nav-data-access');
var NavFactory = require('./nav-factory');
var NavLinkGenerator = require('./nav-link-generator');
var trackingConst = require('src/interlock/no-ui/tracking/constant');

var NavPopulator = function() {

    this.populateModels = function(controller, parentId, publicationState, isDrawer) {
        var domElement = isDrawer ? NavDrawerDomElement : NavDomElement;
        var template = isDrawer ? NavDrawerTemplate : NavTemplate;
        var modelsListDiv = domElement.getMakeModelYearDom(parentId).modelsListDiv;
        modelsListDiv.empty();
        NavDataAccess.getDataObj().forEach(function (submodel) {
            var anchor = null;
            if(publicationState !== 'new') {
                anchor = template.modelAnchor(submodel);
                anchor.on('click', function (e) {
                    if(controller) {
                        controller.modelAnchorSelect(this, e);
                    }
                });
            } else {
                var url = NavLinkGenerator.getLinkOutUrl({
                    submodel: submodel,
                    publicationState: publicationState
                });
                anchor = template.linkOutAnchor(url, submodel.name);
            }
            anchor.attr('data-type', publicationState);
            anchor.attr('data-parent-id', parentId);
            anchor.attr(trackingConst.DATA_TRACKING_ID_ATTRIBUTE, 'nav_mmy_model_select');
            anchor.attr(trackingConst.DATA_TRACKING_VALUE_ATTRIBUTE, submodel.modelNiceId);
            modelsListDiv.append(anchor);
        });
        if(!isDrawer) {
            modelsListDiv.fadeIn(300);
        }
    };

    this.populateYears = function(controller, parentId, publicationState, isDrawer) {
        var domElement = isDrawer ? NavDrawerDomElement : NavDomElement;
        var template = isDrawer ? NavDrawerTemplate : NavTemplate;
        var yearsListDiv = domElement.getMakeModelYearDom(parentId).yearsListDiv;
        yearsListDiv.empty();
        var submodelYears = NavDataAccess.getDataObj().filter(function (submodel) {
            return submodel.name === NavFactory.getSelected().submodel.name;
        })[0].years;

        if(publicationState === 'used') {
            this.addSeeAllForSaleLink(yearsListDiv);
        }

        submodelYears.forEach(function (year) {
            var url = NavLinkGenerator.getLinkOutUrl({
                year: year,
                publicationState: publicationState
            });
            var anchor = template.linkOutAnchor(url, year);

            anchor.attr(trackingConst.DATA_TRACKING_ID_ATTRIBUTE, 'nav_mmy_year_select');
            anchor.attr(trackingConst.DATA_TRACKING_VALUE_ATTRIBUTE, year);
            yearsListDiv.append(anchor);
        });
        if(!isDrawer) {
            yearsListDiv.fadeIn(300);
        }
    };

    this.addSeeAllForSaleLink = function(yearsListDiv) {
        var seeAllForSaleLink = document.createElement('a'),
            selected = NavFactory.getSelected(),
            src = window.EDM.PageValues.page.timestamp;

        seeAllForSaleLink.href = '/used-cars-for-sale/i/' + selected.make.niceName + '/' + selected.model.niceName + '/?src=' + src;
        seeAllForSaleLink.classList.add('anchor', 'text-capitalize');
        seeAllForSaleLink.innerHTML = 'See All For Sale';

        yearsListDiv.append(seeAllForSaleLink);
    };
};

module.exports = new NavPopulator();



//////////////////
// WEBPACK FOOTER
// ./src/interlock/nav/nav-populator.js
// module id = 25
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14